const SegnalazioneTypeLabels : {[key: string]: string} = {
    STOR:"STOR",
    "Market Observation": "Market Observation",
    ALTRO : "Altro",
    Altro : "Altro",
    HELP_DESK_STOR: "Help Desk STOR"
}

export default SegnalazioneTypeLabels